import React from 'react';
import { CheckCircle2, Quote, Eye, Target } from 'lucide-react';
import { expertise, vision, mission } from '../data/mock';

const Leadership = () => {
  return (
    <section id="leadership" className="relative py-24 bg-slate-50 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pattern-grid" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
            <span className="text-blue-700 text-xs font-semibold uppercase tracking-wider">Leadership</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4 font-display">
            Experienced <span className="gradient-text">Leadership</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Over two decades of global experience in digital transformation and enterprise solutions.
          </p>
        </div>

        {/* Expertise Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
          {expertise.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-5 rounded-2xl bg-white border border-slate-200 hover:border-blue-200 transition-colors shadow-sm hover:shadow-lg hover:shadow-blue-500/5"
            >
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                <CheckCircle2 className="w-5 h-5 text-white" />
              </div>
              <span className="text-slate-700 font-medium">{item}</span>
            </div>
          ))}
        </div>

        {/* Vision & Mission */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Vision */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="relative p-8 lg:p-10 rounded-3xl bg-white border border-slate-200 hover:border-blue-200 transition-colors h-full shadow-sm hover:shadow-xl hover:shadow-blue-500/10">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center mb-6 shadow-lg shadow-blue-500/20">
                <Eye className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 font-display">
                Our <span className="gradient-text">Vision</span>
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {vision}
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="relative p-8 lg:p-10 rounded-3xl bg-white border border-slate-200 hover:border-cyan-200 transition-colors h-full shadow-sm hover:shadow-xl hover:shadow-cyan-500/10">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-500 flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/20">
                <Target className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 font-display">
                Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-500">Mission</span>
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {mission}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Leadership;
